
import Attachment from "../drag_and_drop/Attachment/Attachment.vue";
import valid_preset from "../validacion_presentacion/validacion_presentacion.vue";

export default {
  props: ['fecha_declac','filtro','data', 'tipo_regimen'],
  components: {
    Attachment,
    valid_preset,
  },
  data() {
    return {
      dialog: false,
      e1: 1,
      loading: false,
      search1: "",
      search2: "",
      archivo: [],
      facturas: [],
      retenciones: [],
      retencionesIVA: [],
      headers1: [
        {
          text: "NIT Retenedor",
          align: "center",
          sortable: true,
          value: "nit_retenedor",
        },
        {
          text: "Nombre Retenedor",
          align: "center",
          sortable: true,
          value: "nombre_retenedor",
        },
        {
          text: "Estado Constancia",
          align: "center",
          sortable: true,
          value: "estado_constancia",
        },
        {
          text: "Constancia",
          align: "center",
          sortable: true,
          value: "constancia",
        },
        {
          text: "Fecha Emision",
          align: "center",
          sortable: true,
          value: "fecha_emision",
        },
        {
          text: "Total Factura Q",
          align: "end",
          sortable: true,
          value: "total_factura",
        },
        {
          text: "Importe Neto Q",
          align: "center",
          sortable: true,
          value: "importe_neto",
        },
        {
          text: "Afecto Retencion Q",
          align: "center",
          sortable: true,
          value: "afecto_retencion",
        },
        {
          text: "Total Retencion Q",
          align: "end",
          sortable: true,
          value: "total_retencion",
        },
      ],
      headers_isr: [
        {
          text: "NIT Retenedor",
          align: "center",
          sortable: true,
          value: "nit_retenedor",
        },
        {
          text: "Nombre Retenedor",
          align: "center",
          sortable: true,
          value: "nombre_retenedor",
        },
        {
          text: "Estado Constancia",
          align: "center",
          sortable: true,
          value: "estado_constancia",
        },
        {
          text: "Constancia",
          align: "center",
          sortable: true,
          value: "constancia",
        },
        {
          text: "Fecha Emision",
          align: "center",
          sortable: true,
          value: "fecha_emision",
        },
        {
          text: "Total Factura Q",
          align: "end",
          sortable: true,
          value: "total_factura",
        },
        {
          text: "Renta Imponible",
          align: "center",
          sortable: true,
          value: "renta_imponible",
        },
        {
          text: "Total Retencion Q",
          align: "end",
          sortable: true,
          value: "total_retencion",
        },
      ],
      headers2: [
        {
          text: "Fecha de emisión",
          align: "center",
          sortable: true,
          value: "fecha_emision",
        },
        {
          text: "Número de Autorización",
          align: "center",
          sortable: true,
          value: "numero_autorizacion",
        },
        {
          text: "Tipo de DTE (nombre)",
          align: "center",
          sortable: true,
          value: "tipo_dte",
        },
        {
          text: "Serie",
          align: "center",
          sortable: true,
          value: "serie",
        },
        {
          text: "Número del DTE",
          align: "center",
          sortable: true,
          value: "numero_dte",
        },
        {
          text: "NIT del emisor",
          align: "center",
          sortable: true,
          value: "nit_emisor",
        },
        {
          text: "Nombre completo del emisor",
          align: "center",
          sortable: true,
          value: "nombre_emisor",
        },
        {
          text: "Código de establecimiento",
          align: "center",
          sortable: true,
          value: "codigo_establesimiento",
        },
        {
          text: "Nombre del establecimiento",
          align: "center",
          sortable: true,
          value: "nombre_establesimiento",
        },
        {
          text: "ID del receptor",
          align: "center",
          sortable: true,
          value: "nit_receptor",
        },
        {
          text: "Nombre completo del receptor",
          align: "center",
          sortable: true,
          value: "nombre_receptor",
        },
        {
          text: "NIT del Certificador",
          align: "center",
          sortable: true,
          value: "nit_certificador",
        },
        {
          text: "Nombre completo del Certificador",
          align: "center",
          sortable: true,
          value: "nombre_certificador",
        },
        {
          text: "Moneda",
          align: "center",
          sortable: true,
          value: "moneda",
        },
        {
          text: "Monto (Gran Total)",
          align: "end",
          sortable: true,
          value: "monto",
        },
        {
          text: "Marca de anulado ",
          align: "center",
          sortable: true,
          value: "anulado",
        },
        {
          text: "IVA (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_iva",
        },
        {
          text: "Petróleo (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_petroleo",
        },
        {
          text: "Turismo Hospedaje (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_turismo_hospedaje",
        },
        {
          text: "Turismo Pasajes (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_turismo_pasajes",
        },
        {
          text: "Timbre de Prensa (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_timbre_prensa",
        },
        {
          text: "Bomberos (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_bomberos",
        },
        {
          text: "Tasa Municipal (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_tasa_municipal",
        },
        {
          text: "Bebidas alcohólicas (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_bebidas_alcoholicas",
        },
        {
          text: "Tabaco (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_tabaco",
        },
        {
          text: "Cemento (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_cemento",
        },
        {
          text: "Bebidas no Alcohólicas (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_bebidas_no_alcoholicas",
        },
        {
          text: "Tarifa Portuaria (monto de este impuesto)",
          align: "center",
          sortable: true,
          value: "monto_tarifa_portuaria",
        },
      ],
      mes_declaracion: -1,
      anio: -1,
      recibidas: [],
      loading_validar_retenciones: false,
      agente_retenedor: false,
      loading_check: false,
      cargacortesia: false,
      mostrarvalid_preset: false,
      Remanente_ISR: null,
      Remanente_IVA: null,
      validacion_presentacion: false,
      carga: true,
      isisr_pc: 2,
    }
  },

  async created() {
    console.log("ingreso_facturas.created");

    console.log('this.fecha_declac',this.fecha_declac);
    if(this.fecha_declac){
      this.data.fecha = this.fecha_declac;
      console.log('this.data.fecha del if',this.data.fecha);
    }

    if (this.data.facturas) {
      this.e1 = 3;
    }

    try{
    let fecha_solicitada = this.data.fecha;
    fecha_solicitada = fecha_solicitada.split("-");
    let mes = parseInt(fecha_solicitada[1]);
    let mes_declaracion = mes - 1;
    let anio = parseInt(fecha_solicitada[0])
    mes === 1 ? (anio = anio - 1, mes_declaracion = 12) : console.log("anio: " + anio);
    this.mes_declaracion = mes_declaracion;
    this.anio = anio;
    }catch(error){
      console.log(error);
    }

    console.log('this.data.usuario_id', this.data.usuario_id);
    console.log('filtro os', this.filtro);
    console.log('filtro 2', this.data);
    try {
      let r = await this.$store.state.services.presentacionService.validacion_presentacion(this.data.usuario_id);
      if(this.filtro == true){
        this.isisr_pc = -2;
        console.log('if filtro os true');
        if (r.data.data == false) {
          this.mostrarvalid_preset = true;
          this.carga = false;
        }else{
          this.validacion_presentacion = true;
          this.carga = false;
        }
      }else{
        console.log('else filtro os false');
        this.carga = false;
        this.mostrarvalid_preset = true;
        this.headers_isr = this.headers1;
      }
      
    } catch (error) {
      console.log(error);
      this.$toast.error("Error al obtener las facturas");
    }
  },
  watch: {
    data() {
      console.log('data');
      if (this.data.facturas) {
        this.e1 = 3;
      }
    }
  },
  computed: {
    totalFacturas() {
      console.log('totalFacturas');
      let total = 0;
      this.facturas.forEach(x => {
        total = total + x.registros.length;
      });
      return total;
    },
    totalRetenciones() {
      console.log('totalRetenciones');
      let total = 0;
      this.retenciones.forEach(x => {
        total = total + x.registros.length;
      });
      return total;
    },
    totalRetencionesIVA() {
      console.log('totalRetencionesIVA');
      let total = 0;
      this.retencionesIVA.forEach(x => {
        total = total + x.registros.length;
      });
      return total;
    },
    totalRecibidas() {
      console.log('totalRecibidas');
      let total = 0;
      this.recibidas.forEach(x => {
        total = total + x.registros.length;
      });
      return total;
    },
    totalSumaRetenciones() {
      console.log('totalSumaRetenciones');
      if (this.retenciones.length == 0) {
        return 0;
      }
      let retenciones = this.retenciones[0].registros;
      let total = 0
      retenciones.filter(x => {
        total = parseFloat(total) + parseFloat(x.total_retencion);
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(total);
    },
    totalSumaRetencionesIVA() {
      console.log('totalSumaRetencionesIVA');
      if (this.retencionesIVA.length == 0) {
        return 0;
      }
      let retenciones = this.retencionesIVA[0].registros;
      let total = 0
      retenciones.filter(x => {
        total = parseFloat(total) + parseFloat(x.total_retencion);
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(total);
    },
    totalSumaFacturas() {
      console.log("totalSumaFacturas");
      if (this.facturas.length == 0) {
        return 0;
      }
      let facturas = this.facturas[0].registros;
      let total = 0
      facturas.filter(x => {
        if (x.anulado != 'Si') {
          total = parseFloat(total) + parseFloat(x.monto);
        }
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(total);
    },
    totalSumaFacturasRecibidas() {
      console.log("totalSumaFacturasRecibidas");
      if (this.recibidas.length == 0) {
        return 0;
      }
      let facturas = this.recibidas[0].registros;
      let total = 0
      facturas.filter(x => {
        if (x.anulado != 'Si') {
          total = parseFloat(total) + parseFloat(x.monto);
        }
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(total);
    },
    size() {
      const size = { sm: 'small', md: 'small', lg: 'small' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },
  methods: {
    async verificarFacturasRecibidas() {
      console.log("verificarFacturasRecibidas");
      try {
        if (this.tipo_regimen == 1 || this.tipo_regimen == 2) {
          this.e1 = 2;
          console.log('verificarFacturasRecibidas.true');
        } else {
          console.log('verificarFacturasRecibidas.false');
          if (this.recibidas.length == 0) {
            this.$toast.info("Para ROS se requiere al menos una factura recibida");
            return;
          } else {
            this.loading_check = true;
            let r = await this.$store.state.services.presentacionService.validarFacturasSinCategoria({ facturas: this.recibidas[0].registros });
            this.loading_check = false;
            if (r.data.data == 1) {
              this.e1 = 2;
            } else {
              this.e1 = 2;
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = r.data.data
              link.setAttribute('download', `NIT_EMISOR_SIN_CLASIFICAR.pdf`)
              document.body.appendChild(link)
              link.click()
              this.$toast.info("Debes clasificar las facturas que se encuentran en este pdf")
            }
          }
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Error al verificar facturas recibidas");
      }
    },
    mostrarPagina() {
      console.log("mostrarPagina");
      window.open("https://banguat.gob.gt/tipo_cambio/");
    },
    parseXmlToJson(xml) {
      console.log("parseXmlToJson");
      const json = {};
      for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
        const key = res[1] || res[3];
        const value = res[2] && this.parseXmlToJson(res[2]);
        json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;
      }
      return json;
    },
    convertirnumero(numero) {
      console.log("convertirnumero");
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },
    eliminarFactura(index) {
      console.log("eliminarFactura");
      this.facturas.splice(index);
    },
    eliminarRetencion(index) {
      console.log("eliminarRetencion");
      this.retenciones.splice(index);
    },
    eliminarRetencionIVA(index) {
      console.log("eliminarRetencionIVA");
      this.retencionesIVA.splice(index);
    },
    eliminarFacturaRecibida(index) {
      console.log("eliminarFacturaRecibida");
      this.recibidas.splice(index)
    },
    async guardarPresentacion() {
      console.log("guardarPresentacion");
      this.loading = true;
      try {

        let r = null;
        if(this.fecha_declac){
          if (this.data.carga == true) {//ADMIN
            r =
              await this.$store.state.services.presentacionService.presentarFacturas({
                cargacortesia: true,
                aplica_sub: false,
                usuario_id: this.data.id,
                esFactura: this.data.facturas,
                facturas: this.facturas.length === 0 ? this.facturas : this.facturas[0].registros,
                recibidas: this.recibidas.length === 0 ? this.recibidas : this.recibidas[0].registros,
                retenciones: this.retenciones,
                retencionesIVA: this.retencionesIVA,
                fecha: this.data.fecha,
                agente_retenedor: this.agente_retenedor,
                remanente_isr: this.Remanente_ISR,
                remanente_iva: this.Remanente_IVA,
                validacion_presentacion: this.validacion_presentacion,
              });
          } else {
            r =
              await this.$store.state.services.presentacionService.presentarFacturas({
                cargacortesia: true,
                aplica_sub: true,
                usuario_id: this.data.usuario_id,
                esFactura: this.data.facturas,
                facturas: this.facturas.length === 0 ? this.facturas : this.facturas[0].registros,
                recibidas: this.recibidas.length === 0 ? this.recibidas : this.recibidas[0].registros,
                retenciones: this.retenciones,
                retencionesIVA: this.retencionesIVA,
                fecha: this.data.fecha,
                agente_retenedor: this.agente_retenedor,
                remanente_isr: this.Remanente_ISR,
                remanente_iva: this.Remanente_IVA,
                validacion_presentacion: this.validacion_presentacion,
              });
          }
        }else{
          if (this.data.carga == true) {//ADMIN
            r =
              await this.$store.state.services.presentacionService.presentarFacturas({
                cargacortesia: false,
                aplica_sub: false,
                usuario_id: this.data.id,
                esFactura: this.data.facturas,
                facturas: this.facturas.length === 0 ? this.facturas : this.facturas[0].registros,
                recibidas: this.recibidas.length === 0 ? this.recibidas : this.recibidas[0].registros,
                retenciones: this.retenciones,
                retencionesIVA: this.retencionesIVA,
                fecha: this.data.fecha,
                agente_retenedor: this.agente_retenedor,
                remanente_isr: this.Remanente_ISR,
                remanente_iva: this.Remanente_IVA,
                validacion_presentacion: this.validacion_presentacion,
              });
          } else {
            r =
              await this.$store.state.services.presentacionService.presentarFacturas({
                cargacortesia: false,
                aplica_sub: true,
                usuario_id: this.data.usuario_id,
                esFactura: this.data.facturas,
                facturas: this.facturas.length === 0 ? this.facturas : this.facturas[0].registros,
                recibidas: this.recibidas.length === 0 ? this.recibidas : this.recibidas[0].registros,
                retenciones: this.retenciones,
                retencionesIVA: this.retencionesIVA,
                fecha: this.data.fecha,
                agente_retenedor: this.agente_retenedor,
                remanente_isr: this.Remanente_ISR,
                remanente_iva: this.Remanente_IVA,
                validacion_presentacion: this.validacion_presentacion,
              });
          }
        }

        if (r.status === 200) {
          this.$toast.success(
            "DATOS GUARDADOS EXITOSAMENTE"
          );
          this.loading = false;
          this.dialog = false;
          this.agente_retenedor = false;
          this.$emit("regresar", this.data);
        } else {
          this.$toast.error(
            r.data.message
          );
        }

        this.dialog = false;
        this.loading = false;
        this.agente_retenedor = false;
        this.$emit("regresar", this.data);
      } catch (error) {
        console.log(error);
        this.$toast.error(
          "Ocurrió un error fatal al intentar guardar los datos "
        );
        this.loading = false;
        this.dialog = false;
        this.agente_retenedor = false;
        this.$emit("regresar", this.data);
      }
    },
    archivos(file) {
      console.log('archivos', file);
      this.archivo.push(file);
    },
    facturasEmit(obj) {
      console.log('facturasEmit');
      let data = obj.registros;
      data = data.filter(x => parseInt(x.nit_emisor) != parseInt(this.data.nit))
      if (data.length > 0) {
        data.forEach(element => {
          this.$toast.info("Atención, el nit del emisor no coincide en la linea " + element.fila, { timeout: 10000, showCloseButtonOnHover: true, })
        });

        this.$toast.error("Por favor verifica el archivo de excel y vuelve a ingresar de nuevo", { timeout: 10000 });
        return;
      }

      this.facturas.push(obj)
    },
    facturasRecibidas(obj) {
      console.log('facturasRecibidas');
      let data = obj.registros;
      data = data.filter(x => parseInt(x.nit_receptor) != parseInt(this.data.nit))
      if (data.length > 0) {
        data.forEach(element => {
          this.$toast.info("Atención, el nit del emisor no coincide en la linea " + element.fila, { timeout: 10000, showCloseButtonOnHover: true, })
        });
        this.$toast.error("Por favor verifica el archivo de excel y vuelve a ingresar de nuevo", { timeout: 10000 });
        return;
      }
      this.recibidas.push(obj)
    },
    retencionesEmit(obj) {
      console.log('retencionesEmit');
      this.retenciones.push(obj)
    },
    retencionesEmitIVA(obj) {
      console.log('retencionesEmitIVA');
      this.retencionesIVA.push(obj)
    },
    async verificar_retenciones() {
      console.log("verificar_retenciones");
      try {
        this.loading_validar_retenciones = true;
        let r = await this.$store.state.services.presentacionService.validarRetenedores({ facturas: this.facturas[0].registros });
        if (r.data.data != null) {
          this.loading_validar_retenciones = false
          this.data.carga_retencion_isr = 0;
          this.$toast.warning("Atención, el usuario presenta agentes retenedores ISR, debes estar atento a las retenciones en los próximos días para cargar este archivo o bien cargar las retenciones en este instante", { timeout: 6000 })
          this.e1 = 3
          this.agente_retenedor = true;
          await this.verificar_retencionesIVA(true);
        }
        else {
          this.carga_retencion_isr = null;
          await this.verificar_retencionesIVA(false);
        }
      } catch (error) {
        console.log(error, 'no se verifico los retenedores !');
        this.data.carga_retencion_isr = null;
        this.loading_validar_retenciones = false
      }
    },
    async verificar_retencionesIVA(is_retencion_isr) {
      console.log("verificar_retencionesIVA");
      try {
        this.loading_validar_retenciones = true;
        let r = await this.$store.state.services.administradorService.validarAgentesIVA({ facturas: this.recibidas[0].registros });
        if (r.data.data != null) {
          this.loading_validar_retenciones = false
          this.data.carga_retencion_iva = 0;
          this.$toast.warning("Atención, el usuario presenta agentes retenedores IVA, debes estar atento a las retenciones en los próximos días para cargar este archivo o bien cargar las retenciones en este instante", { timeout: 6000 })
          this.e1 = 3
          this.agente_retenedor = true;
        } else if (is_retencion_isr) {

          this.e1 = 3
          this.loading_validar_retenciones = false
          this.data.carga_retencion_iva = null;

        }
        else {
          this.loading_validar_retenciones = false
          this.e1 = 4
          this.data.carga_retencion_iva = null;

        }
      } catch (error) {
        console.log(error, 'no se verifico los retenedores !');
        this.data.carga_retencion_iva = null;
        this.loading_validar_retenciones = false
      }

    },
    ftn_valid_preset() {
      console.log('ftn_valid_preset');
      if ((this.Remanente_ISR == null || this.Remanente_IVA == null) || (this.Remanente_ISR == "" || this.Remanente_IVA == "")) {
        this.$toast.error("Debe ingresar los remanentes de ISR e IVA");
      } else {
        this.mostrarvalid_preset = true;
      }
    }
  },
  async mounted() {
    console.log("_/ingreso_facturas");
  },
}